import { jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { ConciergeProductCard } from "./ConciergeProductCard.js";
import StoreCarousel from "./StoreCarousel.js";
import { ProductCardCarouselWidget } from "@brandclub/bc-widgets";
import { useProductClickTracking } from "./hooks/useProductClickTracking.js";
const ProductGroupCarousel = ({
  products,
  allStacklineSkus = [],
  isLoading = false
}) => {
  const { trackProductClick } = useProductClickTracking();
  const [isMobileView, setIsMobileView] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < 500;
  });
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 500);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  if (isLoading && products.length === 0) {
    return /* @__PURE__ */ jsx("div", { className: "tw:w-full", children: /* @__PURE__ */ jsx(StoreCarousel, { children: [1, 2, 3, 4].map((i) => /* @__PURE__ */ jsx("div", { className: "tw:w-[240px] tw:h-[391.86px] tw:rounded-xl tw:bg-gray-200 tw:animate-pulse" }, i)) }) });
  }
  if ((!products || products.length === 0) && allStacklineSkus.length === 0) {
    return null;
  }
  const productMap = /* @__PURE__ */ new Map();
  products.forEach((product) => {
    productMap.set(product.stacklineSku, product);
  });
  const skusToRender = allStacklineSkus.length > 0 ? allStacklineSkus : products.map((p) => p.stacklineSku);
  return /* @__PURE__ */ jsx(ProductCardCarouselWidget, { widgetId: "product-card-carousel", displayName: "Product Card Carousel", children: (cardStyles, carouselStyles, themeFonts, resolveColor) => {
    const itemWidth = isMobileView ? carouselStyles.itemWidthMobile : carouselStyles.itemWidth;
    return /* @__PURE__ */ jsx("div", { className: "tw:w-full product-group-carousel", children: /* @__PURE__ */ jsx(StoreCarousel, { gap: carouselStyles.carouselGap, children: skusToRender.map((sku, index) => {
      const product = productMap.get(sku);
      if (product) {
        return /* @__PURE__ */ jsx("div", { style: { width: itemWidth, minWidth: itemWidth }, children: /* @__PURE__ */ jsx(
          ConciergeProductCard,
          {
            product,
            cardStyles,
            themeFonts,
            resolveColor,
            onProductClick: () => {
              trackProductClick({
                stacklineSku: product.stacklineSku,
                productTitle: product.title,
                clickSource: "carousel",
                productPosition: index,
                retailerId: product.retailerId,
                retailPrice: product.retailPrice,
                hasReward: product.hasRewards,
                rewardAmount: product.totalRewardAmount
              });
            }
          }
        ) }, sku);
      }
      return null;
    }) }) });
  } });
};
export {
  ProductGroupCarousel
};
//# sourceMappingURL=ProductGroupCarousel.js.map
